module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopping"
  }, [_c('mt-header', {
    attrs: {
      "title": "购物车"
    }
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('NavBar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "emptyShopping"
  }, [_c('p', [_vm._v("你的购物车没有任何商品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e24794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shopping.vue
// module id = 228
// module chunks = 1